import { useEffect, useRef } from 'react'
import { useMap } from 'react-leaflet'
import L, { latLngBounds } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import 'leaflet.markercluster'
import MarkerClusterGroup from 'react-leaflet-markercluster'
import WreckMarker from './WreckMarker'
import './WreckMarkerClusters.css'

const WreckMarkerClusters = ({
  wrecksToShow,
  filteredWrecks,
  allWrecks,
  wreckId,
  fitMapToMarkers,
  areMapOptionsToggled,
  clearAll,
  setClearAll,
  merikarttaLayer,
}) => {
  const clusterRef = useRef()
  const map = useMap()
  useEffect(() => {
    if (!wrecksToShow?.length) return
    if (wreckId === 0 && fitMapToMarkers) {
      const markerBounds = latLngBounds(
        wrecksToShow.map((wreck) => [Number(wreck.meta.gpsLatitude[0]), Number(wreck.meta.gpsLongitude[0])]),
      )
      map.fitBounds(markerBounds)
    }
  }, [filteredWrecks, wreckId, map])

  useEffect(() => {
    if (clearAll) {
      const markerBounds = latLngBounds(
        allWrecks.map((wreck) => [Number(wreck.meta.gpsLatitude[0]), Number(wreck.meta.gpsLongitude[0])]),
      )
      map.fitBounds(markerBounds)
      setClearAll(false)
    }
  }, [clearAll])

  const createClusterCustomIcon = function (cluster) {
    const minZoomed = map.getZoom() >= merikarttaLayer.minZoom
    const style = `marker-cluster-custom ${merikarttaLayer.checked && minZoomed ? 'merikartta' : ''}`
    return L.divIcon({
      html: `<span>${cluster.getChildCount()}</span>`,
      className: style,
      iconSize: L.point(45, 45, true),
    })
  }

  return (
    <MarkerClusterGroup
      ref={clusterRef}
      key={new Date().getTime()} // Force re-render on each update
      disableClusteringAtZoom={13}
      showCoverageOnHover={false}
      spiderfyOnMaxZoom={false}
      iconCreateFunction={createClusterCustomIcon}
    >
      {wrecksToShow.map((wreck) => (
        <WreckMarker
          key={wreck.id}
          wreck={wreck}
          id={wreckId}
          centerAndZoom={areMapOptionsToggled ? false : wreckId === wreck.id}
        />
      ))}
    </MarkerClusterGroup>
  )
}
export default WreckMarkerClusters
